/**
 * Session types of a practice session, mirroring the backend `ActivitySessionTypeEnum`. The API
 * returns one of these raw values as `sessionType`, both when creating a session and when reading
 * it back.
 *
 * `KC` is a volatile single-KC practice launched from the "Practicar" button of an improvement area
 * (TANAI-2087). It is persisted — its activity instances and BKT progress hang from it — but it is
 * deliberately NOT one of the types the "Today" listing whitelists, so it never shows up as a
 * pending recommendation, and it does not reserve its KC against the tutor's own generation.
 *
 * It lives in `constants/` — next to `SESSION_STATUS` — because it is shared across layers: the
 * launch flow (`useKcPracticeFlow`) and the type recognition consumed by the practice view and the
 * exit flow (`challengeTypeUtils`).
 */
export const SESSION_TYPE = Object.freeze({
  PRACTICE: 'PRACTICE',
  NEW: 'NEW',
  STUDENT: 'STUDENT',
  TEACHER: 'TEACHER',
  KC: 'KC',
} as const);

export type SessionType = (typeof SESSION_TYPE)[keyof typeof SESSION_TYPE];
